const baseFontSize = '16pt';
const headerSize = 146;
const headerSizeSmall = 50;

module.exports = {
    purge: {
        enabled: true,
        content: ['./src/**/*.vue', './data/app_config.json'],
        // options: {
        //     whitelistPatterns: [/text-(primary|secondary|neutral)-\S+/]
        // }
    },
    headerSize,
    theme: {
        screens: {
            short: [
                { raw: '(max-height: 840px) and (min-width: 840px)' },
                { raw: '(max-height: 640px) and (max-width: 839px)' }
            ],
            mobile: { max: '839px' },
            sm: '840px',
            md: '1171px',
            lg: '1320px'
        },
        fontFamily: {
            display: ['"Cabin"', 'Arial'],
            body: ['"Cabin"', 'Arial']
        },
        spacing: {
            header: `${headerSize}px`,
            'content-height': `calc(100vh - ${headerSize}px)`,
            'header-sm': `${headerSizeSmall}px`,
            'content-height-sm': `calc(100vh - ${headerSizeSmall}px)`,
            px: '1px',
            0: '0',
            1: `calc(0.25 * ${baseFontSize})`,
            2: `calc(0.5 * ${baseFontSize})`,
            3: `calc(0.75 * ${baseFontSize})`,
            4: `calc(1 * ${baseFontSize})`,
            5: `calc(1.25 * ${baseFontSize})`,
            6: `calc(1.5 * ${baseFontSize})`,
            8: `calc(2 * ${baseFontSize})`,
            10: `calc(2.5 * ${baseFontSize})`,
            12: `calc(3 * ${baseFontSize})`,
            16: `calc(4 * ${baseFontSize})`,
            20: `calc(5 * ${baseFontSize})`,
            24: `calc(6 * ${baseFontSize})`,
            32: `calc(8 * ${baseFontSize})`,
            40: `calc(10 * ${baseFontSize})`,
            48: `calc(12 * ${baseFontSize})`,
            56: `calc(14 * ${baseFontSize})`,
            64: `calc(16 * ${baseFontSize})`,
        },
        minHeight: {
            'screen-sm': `calc(100vh - ${headerSizeSmall}px)`
        },
        borderRadius: {
            none: '0',
            sm: `calc(0.125 * ${baseFontSize})`,
            default: `calc(0.25 * ${baseFontSize})`,
            lg: `calc(0.5 * ${baseFontSize})`,
            full: '9999px',
        },
        fontSize: {
            '2xs': '12px',
            xs: '14px',
            sm: '16px',
            base: '18px',
            lg: '20px',
            xl: '24px',
            '2xl': '30px',
            '3xl': '36px',
            '4xl': '48px',
            '5xl': '60px',
            '6xl': '72px'
            // xs: `calc(0.75 * ${baseFontSize})`,
            // sm: `calc(0.875 * ${baseFontSize})`,
            // base: `calc(1 * ${baseFontSize})`,
            // lg: `calc(1.125 * ${baseFontSize})`,
            // xl: `calc(1.25 * ${baseFontSize})`,
            // '2xl': `calc(1.5 * ${baseFontSize})`,
            // '3xl': `calc(1.875 * ${baseFontSize})`,
            // '4xl': `calc(2.25 * ${baseFontSize})`,
            // '5xl': `calc(3 * ${baseFontSize})`,
            // '6xl': `calc(4 * ${baseFontSize})`,
        },
        fontWeight: {
            normal: 400,
            bold: 700
        },
        extend: {
            inset: {
                'header-sm': `${headerSizeSmall}px`,
                header: `${headerSize}px`
            },
            boxShadow: {
                tooltip: '1px 1px 2px 1.5px rgba(0,0,0, .15)',
            },
            lineHeight: {
                tight: 1.2,
                snug: 1.4,
                relaxed: 1.7
            },
            colors: {
                primary: {
                    1: '#15476D',
                    2: '#055A94',
                    3: '#12749E',
                    4: '#009AA8',
                    5: '#26BA7E',
                    6: '#71DF64',
                    7: '#32BFC7',
                    8: '#12749E',
                    9: '#627987'
                },
                neutral: {
                    1: '#2E393F',
                    2: '#515D62',
                    3: '#8D989E',
                    4: '#DBE0E4',
                    5: '#F2F7FA',
                    text: '#555555',
                    line: '#666666',
                    label: '#7A7A7A',
                    info: '#96999D',
                    button: '#D9D9D9',
                    input: '#999999'
                },
                secondary: {
                    green: '#9FCF55',
                    green2: '#2FB77D',
                    green3: '#7EC460',
                    orange: '#E9AE30',
                    blue: '#99DEFD',
                    teal: '#54BFAD'
                },
                print: {
                    1: '#254A6A',
                    6: '#31B980',
                    7: '#56C0AD',
                    dark: '#777777',
                    light: '#FFFFFF',
                    strong: '#444444',
                    // TODO: Remove references to nested, use above non nested instead
                    primary: {
                        1: '#254A6A',
                        6: '#31B980',
                        7: '#56C0AD'
                    }
                },
            }
        }
    }
};
